require('../player/player');
require('../fhApp/transformResource');
require('../shared/dataTransformers/clipTransformer');

angular.module('app.shared.singleGameService', [
  'app.player',
  'app.transformResource',
  'app.shared.dataTransformers.clipTransformer'
])
  .factory('app.shared.singleGameService', [
    '$http',
    '$httpParamSerializerJQLike',
    '$q',
    '$rootScope',
    'app.transformResource',
    'app.shared.dataTransformers.clipTransformer',
    function ($http, $httpParamSerializerJQLike, $q, $rootScope, transformResource, clipTransformer) {
      "use strict";

      /**
       * @type {SingleGameService}
       */
      let game = {
        data: null,
        clips: [],
        areMoreClips: false,
        error: null,
        clear: function () {
          game.data = null;
          game.error = null;
        },
        retrieve: function (game_id, params, assign_game = true) {

          params = $httpParamSerializerJQLike(params);
          if (game_id) {
            return $http.get(window.location.api('games/' + game_id + '?' + params))
              .then(
                /**
                 * @param {HttpResponse} response
                 */
                (response) => {
                  /**
                   * @type {{game: Game, error: *}}
                   */
                  if (assign_game) {
                    let data = response.data;
                    game.data = game.load(data.game, data.error);
                  } else {
                    return response
                  }
                }
              );
          }
        },
        load: function (game_obj, error) {
          game.data = game_obj;
          game.error = error;

          $rootScope.$broadcast('singleGameReady');
          return game.data;
        },
        unload: function () {
          game.load(null, null);
        },
        copy: function (data) {
          let game_copy;
          game_copy = angular.copy(game);
          if (data) {
            game_copy.load(data);
          }
          return game_copy;
        },
        save_overlay: function () {
          "use strict";

          if (game.data && game.data.overlay) {
            $http.put(window.location.api('admin/games/' + game.data.igameid + '/overlay'),
              {
                overlay: game.data.overlay
              }
            )
              .then((response) => {
                let data = response.data;

                if (data.overlay) {
                  game.data.overlay = data.overlay;
                }

                if (data.error) {
                  game.error = data.error;
                }
              });
          }
        },
        createInstantReplay: function (clipOffset, categoryId, options) {
          if (!angular.isObject(options)) {
            options = {};
          }
          options.game_offset = game.data.istarttime;
          options.method = game.data.can_edit ? 'editor' : 'player';

          if (categoryId === null) {
            options.clip_name = 'Quick Clip';
          }

          let data = {
            clip_offset: clipOffset,
            category_id: categoryId,
            options: options
          };

          return $http({
            method: 'POST',
            url: window.location.api('games/' + game.data.igameid + '/instant_replay'),
            transformResponse: transformResource.onResponse(clipTransformer.transformToUi),
            data: data
          })
            .then(function (response) {
              let data = response.data;

              if (data.error) {
                game.error = data.error;
              }
              else {
                let index = game.clips.findIndex((clip) => {
                  return data.iclipid && data.iclipid === clip.iclipid
                });

                if (index <= -1) {
                  game.clips.push(data);
                }
              }

              return response;
            });
        },
        retrieveClips: function (game_id, options) {
          if (!game_id && game.data) {
            game_id = game.data.igameid;
          }

          let appendResult = false;
          if (options) {
            appendResult = options.appendResult;
            delete options.appendResult;
          }

          let params = $httpParamSerializerJQLike(options);

          return $http({
            method: 'GET',
            url: window.location.api('games/' + game_id + '/clips?' + params),
            transformResponse: transformResource.onResponse((data) => {
              if (!data.error && Array.isArray(data)) {
                let clips = [];
                _.forEach(data, (clip) => {
                  clips.push(clipTransformer.transformToUi(clip));
                });
                return clips;
              }
              return data;
            })
          })
            .then(function (response) {
              let data = response.data;

              if (data.error) {
                game.error = data.error;
              }
              else {
                game.areMoreClips = false;
                if (options && options.limit) {
                  if (Array.isArray(data) && data.length >= options.limit) {
                    game.areMoreClips = true;
                  }
                }

                if (appendResult && Array.isArray(game.clips)) {
                  game.clips = game.clips.concat(data);
                } else {
                  game.clips = data;
                }
              }

              return response;
            });
        },
        getMoreClips: (options) => {
          if (Array.isArray(game.clips)) {
            if (!options) options = {};

            options = Object.assign(
              {},
              {
                appendResult: true,
                limit: 250
              },
              options
            );

            options.offset = game.clips.length;

            return game.retrieveClips(null, options);
          }
        },
        logPlayed: function (game_id, audio) {
          let deferred = $q.defer();

          (_.debounce(() => {
            if (typeof game_id === 'undefined' && game.data) {
              game_id = game.data.igameid;
            }

            $http.post(window.location.api('games/' + game_id + '/played' + (audio ? '/' + audio : '')))
              .then((response) => {
                deferred.resolve(response);
              });
          }, 5000))();

          return deferred.promise;
        },
        updatePlayedTime: function (watchedGameId) {
          return $http.put(window.location.api('game/mark_end_time/' + watchedGameId));
        },
        getStreamUrl: function (audio) {
          if (game.data) {
            if (!audio) {
              return $http.get(window.location.api('games/' + game.data.igameid + '/stream_url'));
            }
            else {
              return $http.get(window.location.api('games/' + game.data.igameid + '/stream_url/' + audio));
            }
          }
        },
        transform: function (data) {
          if (data) {
            if (data.overlay) {
              data.overlay.splitText = game.splitOverlayText(data.overlay.stroverlayoverride);
            }
          }

          return data;
        },
        splitOverlayText: function (txt) {
          let arr = ['', '', ''];
          if (txt) {
            if (txt.match(/;/)) {
              let split = txt.split(';');
              arr = [
                split[0],
                split[1],
                split[2]
              ];
            }
          }
          return arr;
        },
        saveLine: function (igameid, iteamid, linenumber, data, callback) {

          $http.put(window.location.api('/games/' + igameid + "/lineup/" + iteamid + "/" + linenumber), data)
            .then((response) => {
              let data = response.data;

              if (typeof callback !== 'undefined' && typeof callback === 'function') {
                callback(data);
              }
            });
        }
      };

      return game;
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/shared/singleGameService.js